// 入力値検証ユーティリティ
import { AppConfig } from '../config.js';

export interface ValidationResult {
  isValid: boolean;
  errorMessage: string | null;
}

export class ValidationUtils {
  static validateFileSize(value: number): ValidationResult {
    if (isNaN(value)) {
      return { isValid: false, errorMessage: null };
    }

    const config = AppConfig.generation;
    
    if (value < config.minFileSize) {
      return { 
        isValid: false, 
        errorMessage: `ファイルサイズは${config.minFileSize}バイト以上である必要があります` 
      };
    }
    
    if (value > config.maxFileSize) {
      return { 
        isValid: false, 
        errorMessage: `ファイルサイズは${(config.maxFileSize / 1024 / 1024).toFixed(0)}MB以下である必要があります` 
      };
    }
    
    return { isValid: true, errorMessage: null };
  }

  static formatFileSize(bytes: number): string {
    if (isNaN(bytes) || bytes <= 0) {
      return '';
    }

    let sizeText = `${bytes.toLocaleString()}バイト`;
    
    if (bytes >= 1024) {
      if (bytes < 1024 * 1024) {
        sizeText += ` (${(bytes / 1024).toFixed(2)}KB)`;
      } else {
        sizeText += ` (${(bytes / 1024 / 1024).toFixed(2)}MB)`;
      }
    }
    
    return `約${sizeText}`;
  }
} 